import _extends from "@babel/runtime/helpers/extends";
import _objectWithoutProperties from "@babel/runtime/helpers/objectWithoutProperties";
const _excluded = ["className", "minDate", "maxDate"];
import React, { useCallback } from 'react';
import { createUseStyles, DatePicker } from 'hoi-poi-ui';
import PropTypes from 'prop-types';
import classnames from 'classnames';
import { useWeb5Context } from "../../../../lib/Web5Context";
import { formatDate, DATE_PLACEHOLDERS } from "../../../../lib/dates";
import styles from "./styles";
const useStyles = createUseStyles(styles, 'Date');
function Date(_ref) {
  let {
      className,
      minDate,
      maxDate
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  const {
    language,
    locale
  } = useWeb5Context();
  const classes = useStyles();
  const format = useCallback(value => {
    return formatDate(value, locale, 'P');
  }, [locale]);
  const placeholders = DATE_PLACEHOLDERS[locale];
  const classNames = classnames(classes.root, className);
  return /*#__PURE__*/React.createElement("div", {
    className: classNames
  }, /*#__PURE__*/React.createElement(DatePicker, _extends({
    labelMode: "horizontal"
  }, props, {
    lang: language,
    formatDate: format,
    placeholder: placeholders,
    minDate: minDate,
    maxDate: maxDate
  })));
}
process.env.NODE_ENV !== "production" ? Date.propTypes = {
  uiGrid: PropTypes.string
} : void 0;
export default /*#__PURE__*/React.memo(Date);